import { InsightPanel } from '@/components/reporting/InsightPanel';
export default function TemperatureAnalysis(props) { return <InsightPanel type="temperature" {...props}/>; }